<template>
  <RichText :field="membershipBenefit?.fields.membershipBenefitHeading" class="text-lg-bold pb-5" />

  <div v-for="(mb, index) of membershipBenefit.benefits" :key="index">
    <RichText :field="{ value: mb.fields.membershipBenefitHeading.value }" class="text-lg-bold pb-3" />
    <RichText :field="{ value: formatText(mb?.fields.membershipBenefitSummaryText.value) }" class="text-base" />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { getInsuranceTypeDisplayName, InsuranceQuoteType, QuoteTypeCodes } from '@/interfaces';

const translation = useI18n();
const dictionary: Record<string, string> = translation.getLocaleMessage('en') as any;

const props = defineProps<{
  membershipBenefit: any;
  showIcons: boolean;
  quoteType: InsuranceQuoteType;
}>();

function formatText(text: string) {
  if (!text) return text;
  return text.replaceAll('{0}', getInsuranceTypeDisplayName(dictionary, QuoteTypeCodes[props.quoteType], true));
}
</script>
